import { useTranslation } from "react-i18next";
import { activitésEntreprise } from "../Utils/Listings";
import MultiSelector from "./MultiSelector";

const EditActivité = (props) => {
    const { i18n } = useTranslation('common');
    return (
        <MultiSelector {...props} valuesListing={activitésEntreprise} label={i18n.language === "fr" ? "Activité de l'entreprise*" : "Company activity*"} />
    );
}

export default EditActivité;